import { useState } from 'react';

export const useDialog = () => {
  const [open, setOpen] = useState(false);
  const [dialogProps, setDialogProps] = useState({});

  const openDialog = (props = {}) => {
    setDialogProps(props);
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
    setDialogProps({});
  };

  return {
    open,
    dialogProps,
    openDialog,
    closeDialog
  };
};